/**
 * Escapa caracteres especiales XML según la sección 6.1.3 de la Ficha Técnica DGI V1.00
 * Los caracteres >, <, &, ", ' deben ser escapados para no romper el XML ni el código QR.
 */
export const escapeXml = (text: string | null | undefined): string | null => {
  if (!text) return text as null;

  return text
    .replace(/&/g, '&amp;')   // & primero para no doble-escapear
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
};

/**
 * Revierte el escape XML — restaura caracteres especiales desde entidades XML.
 * Se usa al leer payloads almacenados (clonar factura, nota de crédito, etc.)
 * para que los nombres de productos, clientes y direcciones se muestren correctamente.
 */
export const unescapeXml = (text: string | null | undefined): string => {
  if (!text) return '';

  return text
    .replace(/&#39;/g, "'")
    .replace(/&quot;/g, '"')
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/&amp;/g, '&');   // & al final para no doble-desescapear
};
